export default class People {
  init(root) {
    this.root = root
    this.items = root.querySelectorAll('.people-item.has-back')

    this.addEvents()
    this.updateOffset()

    window.addEventListener('resize', () => this.updateOffset())
  }

  updateOffset() {
    if (this.root.classList.contains('people-twocolumnoffset') && this.items.length > 0) {
      this.root.style.setProperty('--offset', this.items[0].offsetWidth / 4 + 'px')
    }
  }

  addEvents() {
    this.items.forEach(item => {
      const panelId = item.getAttribute('aria-controls')
      const panel = panelId ? document.getElementById(panelId) : null

      item.addEventListener('click', () => {
        const isActive = item.classList.contains('active')

        // Close all items first
        this.items.forEach(i => {
          i.classList.remove('active')
          i.setAttribute('aria-expanded', 'false')

          const iPanelId = i.getAttribute('aria-controls')
          const iPanel = iPanelId ? document.getElementById(iPanelId) : null
          if (iPanel) iPanel.hidden = true

          // Make all links unfocusable inside closed panels
          const links = i.querySelectorAll('.people-item-mail')
          links.forEach(link => {
            link.setAttribute('tabindex', '-1')
          })
        })

        if (!isActive) {
          item.classList.add('active')
          item.setAttribute('aria-expanded', 'true')
          if (panel) panel.hidden = false

          // Make links inside opened panel focusable again
          const links = item.querySelectorAll('.people-item-mail')
          links.forEach(link => {
            link.removeAttribute('tabindex')
          })
        }
      })

      // Also support Enter and Space keys
      item.addEventListener('keydown', (event) => {
        if (event.key === ' ' || event.key === 'Enter') {
          event.preventDefault()
          item.click()
        }
      })
    })
  }
}
